(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/invite-service.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/invite-service.js');
'use strict';

const jupiterHelper = svs.arena.service.jupiterHelper;
const oldInviteToTeamAsync = async invitationId => {
  const options = {
    method: 'PUT',
    path: "/social/4/syndicates/invitations/".concat(invitationId),
    data: {
      accept: true
    }
  };
  const {
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  return error === null || error === void 0 ? void 0 : error.code;
};
const oldGetInvitationInfoAsync = async invitationId => {
  var _data$invitation, _data$invitation2, _data$invitation3;
  const options = {
    method: 'GET',
    path: "/social/1/syndicates/invitations/".concat(invitationId),
    data: {}
  };
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  return {
    syndicateName: data === null || data === void 0 || (_data$invitation = data.invitation) === null || _data$invitation === void 0 ? void 0 : _data$invitation.syndicateName,
    initialDeposit: data === null || data === void 0 || (_data$invitation2 = data.invitation) === null || _data$invitation2 === void 0 ? void 0 : _data$invitation2.initialDepositAmount,
    teamId: data === null || data === void 0 || (_data$invitation3 = data.invitation) === null || _data$invitation3 === void 0 ? void 0 : _data$invitation3.syndicateId,
    error
  };
};
const inviteToTeamAsync = async invitationId => {
  const options = {
    method: 'PUT',
    path: "/social/2/invitationlinks/".concat(invitationId),
    data: {
      accept: true
    }
  };
  const {
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  return error === null || error === void 0 ? void 0 : error.code;
};
const getInvitationInfoAsync = async invitationId => {
  var _data$syndicate, _data$syndicate2, _data$syndicate3;
  const options = {
    method: 'GET',
    path: "/social/1/syndicates/invitationlinks/".concat(invitationId),
    data: {}
  };
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  return {
    syndicateName: data === null || data === void 0 || (_data$syndicate = data.syndicate) === null || _data$syndicate === void 0 || (_data$syndicate = _data$syndicate.invitationInfo) === null || _data$syndicate === void 0 ? void 0 : _data$syndicate.syndicateName,
    initialDeposit: data === null || data === void 0 || (_data$syndicate2 = data.syndicate) === null || _data$syndicate2 === void 0 || (_data$syndicate2 = _data$syndicate2.invitationInfo) === null || _data$syndicate2 === void 0 ? void 0 : _data$syndicate2.initialDepositAmount,
    teamId: data === null || data === void 0 || (_data$syndicate3 = data.syndicate) === null || _data$syndicate3 === void 0 || (_data$syndicate3 = _data$syndicate3.invitationInfo) === null || _data$syndicate3 === void 0 ? void 0 : _data$syndicate3.syndicateId,
    error
  };
};
const exportedFunctions = {
  oldInviteToTeamAsync,
  oldGetInvitationInfoAsync,
  getInvitationInfoAsync,
  inviteToTeamAsync
};
svs.arena.service.inviteService = exportedFunctions;

 })(window);